import { useTranslation } from "react-i18next";
import { BadgePercent, FileSignature, LayoutDashboard, PackageCheck, Receipt, ScrollText,
         Users } from "lucide-react";
import { ModuleTabs } from "../../components/data/ModuleTabs";

const TABS = [
  { to: "/sales", key: "dashboard", icon: LayoutDashboard, end: true, tone: "sky" },
  { to: "/sales/customers", key: "customers", icon: Users, tone: "emerald" },
  { to: "/sales/quotations", key: "quotations", icon: FileSignature, tone: "amber" },
  { to: "/sales/orders", key: "orders", icon: ScrollText, tone: "violet" },
  { to: "/sales/deliveries", key: "deliveries", icon: PackageCheck, tone: "teal" },
  { to: "/sales/invoices", key: "invoices", icon: Receipt, tone: "rose" },
  { to: "/sales/reps", key: "reps", icon: BadgePercent, tone: "indigo" },
];

// تبويبات قسم المبيعات — نفس نظام الشرائح الملوّنة الموحّد.
export const SalesNav = () => {
  const { t } = useTranslation();
  return (
    <ModuleTabs
      testid="sales-nav"
      tabs={TABS.map((tab) => ({ ...tab, label: t(`sales.tabs.${tab.key}`) }))}
    />
  );
};
